import { createFileRoute, Outlet } from '@tanstack/react-router'

import { GlobalLayout } from '@/components/layouts'

export const Route = createFileRoute('/_authenticated/_with-global-layout')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <GlobalLayout>
      <Outlet />
    </GlobalLayout>
  )
}
